<template>
  <div class="flex flex-col">
    <!-- Items List -->
    <div class="projects-list flex flex-col mt-8 gap-2">
      <div
        class="project-item relative flex justify-between bg-white text-blue px-4 py-5 sm:px-8 sm:py-6 cursor-pointer shadow-transparent"
        v-for="(item, index) in items"
        :key="index"
        :class="
          item.isSold ? 'opacity-30' : 'group hover:scale-[1.01] duration-300'
        "
      >
        <a
          class="absolute inset-0 border border-transparent focus-visible:border-blue/50 group-hover:shadow-md focus-visible:shadow-md duration-300 outline-none text-[0px]"
          :href="item.url"
        >
          {{ item.title }}
        </a>

        <!-- Image -->
        <div
          class="shrink-0 lg:w-[75px] xl:w-[90px] max-w-[90px] lg:h-[75px] xl:h-[90px]"
        >
          <img
            class="object-contain max-w-full max-h-full"
            :src="item.image"
            :alt="item.title"
          />
        </div>

        <!-- Main info wrapp -->
        <div
          class="flex flex-col sm:flex-row w-full justify-between sm:items-center ml-6 sm:mx-6 lg:ml-4 lg:mr-0 xl:mx-10"
        >
          <!-- Main info -->
          <div class="flex flex-col">
            <h3 class="text-lg sm:text-xl xl:text-2xl title">
              {{ item.title }}
            </h3>
            <div class="mt-2 sm:mt-3 text-lg whitespace-nowrap">
              <p v-if="!item.isSold">
                {{ price(item.price) }}
              </p>
              <p v-if="item.isSold">Sold</p>
            </div>
          </div>

          <!-- Params list -->
          <ul
            class="flex flex-col mt-4 sm:mt-0 lg:mt-0 lg:ml-5 xl:ml-8 whitespace-nowrap"
          >
            <li class="flex items-center gap-4" v-if="item.surface">
              <svg class="w-4 h-4">
                <use xlink:href="#gross-floor"></use>
              </svg>

              <span>{{ item.surface }} m<sup>2</sup></span>
            </li>

            <li class="flex items-center gap-4" v-if="item.rooms">
              <svg class="w-4 h-4">
                <use xlink:href="#number-of-rooms"></use>
              </svg>

              <span>{{ item.rooms }} {{pluralize(item.rooms, 'room', 'rooms')}}</span>
            </li>

            <li class="flex items-center gap-4" v-if="item.floors">
              <svg class="w-4 h-4">
                <use xlink:href="#floors"></use>
              </svg>

              <span>{{ item.floors }} {{pluralize(item.floors, 'floor', 'floors')}}</span>
            </li>
          </ul>
        </div>

        <!-- Arrow -->
        <div class="hidden sm:flex lg:hidden xl:flex items-center">
          <div
            class="arrow-diagonal relative w-[18px] h-[18px] overflow-hidden"
          >
            <div class="arrow-diagonal-wrapp w-full h-full">
              <svg
                class="absolute w-[18px] h-[18px] translate-x-[-200%] translate-y-[-200%] group-hover:translate-x-0 group-hover:translate-y-0 duration-500 ease-basic-ease transition-transform"
              >
                <use xlink:href="#arrow-45"></use>
              </svg>

              <svg
                class="absolute w-[18px] h-[18px] group-hover:translate-x-full group-hover:translate-y-full duration-500 ease-basic-ease transition-transform"
              >
                <use xlink:href="#arrow-45"></use>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { addPrefixAndSuffix, formatPrice } from '../../../lib/utils'

export default {
  name: 'projectItems',
  props: {
    items: {
      type: Array,
      default: [],
    },
    pricePrefix: String,
    priceSuffix: String,
  },
  methods: {
    price(number) {
      return addPrefixAndSuffix(formatPrice(number), this.pricePrefix, this.priceSuffix)
    },
    pluralize(number, single, plural) {
      return number === 1 ? single : plural
    }
  },
  data() {
    return {
      translations: window.translations || {},
    }
  }
}
</script>
